<!-- svelte-ignore css-unused-selector -->
<script lang="ts">
    import {createEventDispatcher} from "svelte";
    import {ApplicationData} from "../models/ApplicationData";
     import {convertToCurrency} from "../services/Utilities";
    import {Disclosures, NavigationStateStore} from "../services/Store";
    import {getApplicationsForUser, storeUserApplicationList} from "../services/ApplicationDataService";
    import {getDisclosureList} from "../services/QuestionDataService";
    import {restoreEligibleSetting} from "../services/NavigationService";
    const dispatch = createEventDispatcher();
   export let applicationId: string = '';
    export let applicationDataList: ApplicationData[] = [];

    let selectionDisabled: boolean = false;
    let displayButton: boolean = false;
    $: if ($NavigationStateStore) {
     selectionDisabled =  $NavigationStateStore.lockApplicationSelection == true || $NavigationStateStore.contactMeCompleted == true;
     displayButton = $NavigationStateStore.readyToBeContactedComplete == true && applicationDataList.length > 1;
    }


  const applicationSelected  = () => {
      dispatch('applicationSelected', {
          applicationId: applicationId
      });
    }

    const retrieveApplicationList = async () => {

        if (applicationDataList && applicationDataList.length > 1) {
        await getApplicationsForUser().then(applicationData => {
                storeUserApplicationList(applicationData);
                restoreEligibleSetting();
            });
        }
        selectionDisabled = false;
        displayButton = false;
    }
</script>

   {#if applicationDataList}
 <div class="text-section">

           <div class="control-group-horizontal">
               Select an application to review:
              </div>
     <div class="control-row">
           <div class="control-group-horizontal">
               <select bind:value={applicationId} on:change={applicationSelected} disabled={selectionDisabled}
                       style="font-weight: normal;   font-size: 16px;   font-family: Open Sans, sans-serif;
               min-width: 270px;
               max-width: 560px;
               height: 40px !important;
               color: #4c4c4c;
               border-radius: 2px;
               border: 1px solid #4c12a1;">
                   {#each applicationDataList as data}
                         <option value={data.applicationId}> {data.planDetails.policyNumber} - {convertToCurrency(data.planDetails.faceAmount)}</option>
                   {/each}
               </select>
           </div>
       </div>
 </div>

       {#if (displayButton == true)}
      <div>
               <button class="pl-cta-primary" on:click={retrieveApplicationList}>Refresh Application List</button>
      </div>
       {/if}

   {/if}


<style lang="scss">
  @use "../../component_scss_library/layout" as layout;
  @use "../../component_scss_library/buttons" as buttons;
  @use "../../component_scss_library/forms" as forms;
 </style>
